"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SelectComponentWithRef = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _SelectComponent = _interopRequireDefault(require("./../SelectComponent"));

var _excluded = ["field", "form"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable react/prop-types */

/* prop-types not supported for forwardRef components */


var SelectComponentWithRef = function SelectComponentWithRef(_ref, ref) {
  var field = _ref.field,
      form = _ref.form,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var name = field.name;
  var setFieldValue = form.setFieldValue,
      setTouched = form.setTouched;
  var options = props.options,
      isMulti = props.isMulti,
      onChange = props.onChange;
  var formikRelated = {}; // Integrate Formik touched state

  formikRelated.onBlur = function () {
    setTouched((0, _defineProperty2["default"])({}, name, true));
  }; // Extract chosen value and pass to Formik


  formikRelated.onChange = function (selectedOption, actionType) {
    var getOptionValue = props.getOptionValue || function (option) {
      return option.value;
    };

    if (selectedOption === null) {
      setFieldValue(name, isMulti ? [] : '');
    } else {
      setFieldValue(name, isMulti ? selectedOption.map(function (option) {
        return getOptionValue(option);
      }) : getOptionValue(selectedOption));
    }

    if (onChange) {
      onChange(selectedOption, actionType);
    }
  }; // Loop back the selection to react-select using it's value stored in formik


  formikRelated.value = function () {
    if (options) {
      return isMulti ? options.filter(function (option) {
        return Array.isArray(field.value) ? field.value.some(function (value) {
          return JSON.stringify(value) === JSON.stringify(option.value);
        }) : JSON.stringify(field.value) === JSON.stringify(option.value);
      }) : options.find(function (option) {
        return JSON.stringify(option.value) === JSON.stringify(field.value);
      });
    } else {
      return isMulti ? [] : '';
    }
  }();

  return /*#__PURE__*/_react["default"].createElement(_SelectComponent["default"], (0, _extends2["default"])({
    ref: ref
  }, props, formikRelated));
};
/* eslint-enable react/prop-types */


exports.SelectComponentWithRef = SelectComponentWithRef;
var SelectFormik = /*#__PURE__*/(0, _react.forwardRef)(SelectComponentWithRef);
SelectFormik.propTypes = {
  field: _propTypes.object.isRequired,
  form: _propTypes.object.isRequired,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]),
    label: _propTypes.string
  })).isRequired,
  isMulti: _propTypes.bool
};
var _default = SelectFormik;
exports["default"] = _default;